import React from 'react';
import type { ReactNode } from 'react';
import type { ToastProps } from './Toast';
import { Toast } from './Toast';
import { Interstitial } from '@interstate/components/Interstitial';

export const ToastWithBackdropLoader = ({
    loader,
    hideLoader,
    ...props
}: ToastProps & { loader?: ReactNode; hideLoader?: boolean }) => {
    const { isLoading } = props;

    return (
        <>
            {isLoading && !hideLoader && (loader ?? <Interstitial fullScreen size="small" />)}
            <Toast {...props} />
        </>
    );
};
